import gql from 'graphql-tag';

export const FeedRecommendationQuery = gql`
	query FeedRecommendationQuery {
		getRecommendedFeedUserConfig {
			recommendedSpaces {
				score
				space {
					id
					key
					name
					icon {
						path
					}
				}
			}
			recommendedPeople {
				score
				user {
					id
					title
					displayName
					isActive
					photos {
						value
						isPrimary
					}
				}
			}
		}
		userPreferences {
			feedRecommendedUserSettingsDismissTimestamp
		}
	}
`;
